import reducer from './reducer'

import * as loanAmendmentsOperations from './operations'
import * as loanAmendmentsSelectors from './selectors'

export { loanAmendmentsOperations, loanAmendmentsSelectors }

export default reducer